import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LIFESTYLE } from "@/data/products";

export default function News() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  const categories = ["All", ...Array.from(new Set(items.map((i) => i.category)))];
  const filtered = filter === "All" ? items : items.filter((i) => i.category === filter);

  return (
    <div data-testid="news-page">
      <section className="pt-20 pb-16 bg-neutral-950 text-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="eyebrow text-gold-400 mb-4">Newsroom</div>
          <h1 className="font-display font-bold text-5xl lg:text-6xl tracking-tighter">The latest from SBC.</h1>
        </div>
      </section>
      <section className="py-16 bg-background">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((c) => (
              <button key={c} onClick={() => setFilter(c)} className={`px-4 py-2 rounded-full text-xs font-semibold border transition-colors ${filter === c ? "bg-neutral-950 text-white border-neutral-950 dark:bg-white dark:text-neutral-950 dark:border-white" : "border-border hover:border-gold-400"}`} data-testid={`news-filter-${c.toLowerCase().replace(/\s+/g,'-')}`}>
                {c}
              </button>
            ))}
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((n, i) => (
              <article key={n.id} className="group rounded-2xl overflow-hidden border border-border hover:-translate-y-1 transition-all duration-300" data-testid={`news-card-${n.id}`}>
                <div className="aspect-video overflow-hidden">
                  <img src={Object.values(LIFESTYLE)[i % Object.keys(LIFESTYLE).length]} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 space-y-3">
                  <div className="flex items-center gap-3 text-xs">
                    <span className="text-gold-500 font-bold uppercase tracking-widest">{n.category}</span>
                    <span className="text-muted-foreground">{new Date(n.date).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}</span>
                  </div>
                  <h3 className="font-display font-bold text-xl leading-tight group-hover:text-gold-500 transition-colors">{n.title}</h3>
                  <p className="text-sm text-muted-foreground">{n.excerpt}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
